"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgSentimentScore = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("g", { fill: "#fff", clipPath: "url(#sentiment-score_svg__a)" },
        React.createElement("path", { fillOpacity: 0.48, fillRule: "evenodd", d: "M16.985 0a14.98 14.98 0 0 1 11.98 5.949 15.006 15.006 0 0 1-6.553 23.044 14.98 14.98 0 0 1-12.84-.972L1.43 31.903A.999.999 0 0 1 .097 30.57l3.877-8.15A14.99 14.99 0 0 1 9.39 2.06 14.96 14.96 0 0 1 16.985 0m0 1-.001 1A12.96 12.96 0 0 0 5.633 8.669a12.99 12.99 0 0 0 .322 13.17 1 1 0 0 1 .053.958l-2.896 6.088 6.083-2.9a1 1 0 0 1 .958.054 12.98 12.98 0 0 0 16.454-2.276 13 13 0 0 0 3.172-11.158 13 13 0 0 0-6.994-9.25A13 13 0 0 0 16.987 2z", clipRule: "evenodd" }),
        React.createElement("path", { d: "m16.993 21.5-5.968-6.096a3.44 3.44 0 0 1-.991-1.89 3.4 3.4 0 0 1 .324-2.102c.25-.49.616-.915 1.066-1.24a3.602 3.602 0 0 1 3.177-.505 3.54 3.54 0 0 1 1.412.847l.975.953.975-.953c.395-.388.88-.677 1.411-.846a3.6 3.6 0 0 1 3.176.505c.45.325.816.75 1.066 1.24.331.649.445 1.384.325 2.1a3.43 3.43 0 0 1-.992 1.89z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "sentiment-score_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h32v32H0z" })))));
exports.default = SvgSentimentScore;
